<template>
<standard-dialog v-model="visible" :width="1280" scrollable persistent>

  <template slot="title">
    <span class="title">{{ title }}</span>
  </template>

  <chart-line :data="dataChart" :options="options"></chart-line>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import colors from 'vuetify/es5/util/colors'
import ChartLine from '@/components/charts/Line'

export default {
  name: 'DeviceBatteryChartDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    'standard-dialog': Dialog,
    'chart-line': ChartLine
  },
  data() {
    return {
      rawData: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    title() {
      let name = [this.item.room, this.item.targetName || this.item.name].filter(s => s).join(' ');
      return this.$t('device.battery_of', {
        name: name
      });
    },
    dataJSON() {
      return JSON.parse((this.rawData || {}).result || '[]');
    },
    dataItems() {
      return this.dataJSON.map(k => ({
        t: k[0],
        y: k[1]
      }));
    },
    dataChart() {
      return {
        datasets: [{
          data: this.dataItems,
          borderWidth: 1.5,
          steppedLine: this.isLineStepped,
          lineTension: 0,
          pointRadius: 3,
          borderColor: colors.blue.base,
          backgroundColor: colors.blue.base,
          fill: false
        }]
      };
    },
    options() {
      const ctx = this;
      return {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
              max: new Date().getTime()
            },
            ticks: {
              maxRotation: 0,
              minRotation: 0
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMin: 0,
              suggestedMax: 100
            },
            scaleLabel: {
              display: true,
              labelString: '%'
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'nearest'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false
      };
    },
    ref() {
      let [mac, uid, cid] = this.item.key.split('-');
      return this.$db.ref('macJuice').child(mac).child(`${mac}-${uid}--battery`)
    }
  },
  methods: {
    refresh() {
      let [mac, uid, cid] = this.item.key.split('-');
      this.$db.ref('command/juice').push().set({
        user: this.userId,
        mac: mac,
        uid: uid,
        juice: 'battery'
      });
    }
  },
  mounted() {
    this.refresh();
    this.$bindAsObject('rawData', this.ref, null, null);
  },
  beforeDestroy() {
    this.ref.off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceBatteryChartDialog.vue